import React from 'react';
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import { StripeCheckoutFormProps } from '../types';

export const StripeCheckoutForm: React.FC<StripeCheckoutFormProps> = ({
    clientSecret,
    stripePromise,
}) => {
    if (!clientSecret || !stripePromise) return null;

    return (
        <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
            <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
    );
};
